import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, switchMap, takeUntil } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { BpService } from '../../../../core/services/bp.service';
import { CertificateModalSignatureData } from '../../../../shared/services/signature-nca-common-utils.service';
import { CertificateErrorModalComponent } from '../../../../shared/components/modals/certificate-error/certificate-modal-error.component';
import { BpSubjectFields, BpSubjectForm } from '../register-organization/register-organization.model';
import { ModalService } from '../../../../core/modal/modal.service';
import { AuthApiService } from '../../../../core/modules/auth/auth-api.service';

@Component({
  selector: 'tax-registration-by-eds',
  templateUrl: './registration-by-eds.component.html',
  styleUrls: [],
})

export class RegistrationByEdsComponent implements OnInit, OnDestroy {
  certificateModalSignatureData: CertificateModalSignatureData = {
    type: 'REG',
  };

  showSuccessWindow = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private bpService: BpService,
    private router: Router,
    private modalService: ModalService,
    private authApiService: AuthApiService,
  ) {}

  ngOnInit(): void {
    this.getProcessData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  proceedRegistration(): void {
    const { pid, tid } = this.bpService.getProcessIds();
    this.router.navigate(
      ['/landing/registration/fill-form/'],
      {
        queryParams: {
          pid, tid,
        },
      },
    );
  }

  submitCertificate(certificateModalSignatureData: CertificateModalSignatureData): void {
    const registrationByEdsForm: BpSubjectFields = {
      // @ts-ignore
      salt: certificateModalSignatureData.salt,
      // @ts-ignore
      signature: certificateModalSignatureData.signature.signingDocument,
    };
    this.bpService.submitCurrentBp(registrationByEdsForm)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showSuccessWindow = true;
      }, (httpErrorResponse: HttpErrorResponse) => {
        this.modalService.openOld(
          CertificateErrorModalComponent,
          {
            message: httpErrorResponse.error?.error,
          },
        );
      });
  }

  private getProcessData(): void {
    this.authApiService.getAnonymousUser()
      .pipe(
        switchMap(() => this.bpService.startBpAndGetData('create-user-short', {})),
        switchMap(() => this.bpService.submitAndGetForm({
          verifyBySms: false,
        })),
        takeUntil(this.destroy$),
      )
      // @ts-ignore
      .subscribe((processForm: BpSubjectForm) => {
        this.certificateModalSignatureData = Object.assign(this.certificateModalSignatureData, processForm.fields);
      });
  }
}
